import classNames from 'classnames';
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  color?: string;
}

function getColorClass(color?: string, disabled?: boolean) {
  if (disabled) {
    return 'bg-zinc-500 disabled:bg-zinc-500';
  }

  switch (color) {
    case 'orange':
      return 'bg-primary-orange';
    default:
      return 'bg-primary';
  }
}

// Also used to style a link as a NewButton, so a link never wraps a button.
export function newButtonClassName(
  color?: string,
  className?: string,
  disabled?: boolean
) {
  return classNames(
    getColorClass(color, disabled),
    'rounded-[8px] px-16 py-2 font-semibold text-zinc-50 transition hover:scale-105 shadow-button disabled:!cursor-not-allowed disabled:!scale-100 active:scale-95',
    className
  );
}

function NewButton({ children, color, className, ...rest }: Props) {
  return (
    <button
      className={newButtonClassName(color, className, rest.disabled)}
      {...rest}
    >
      {children}
    </button>
  );
}

export default NewButton;
